// Loox auto-scroll produt page reviews widget
window.addEventListener('load', () => {
  setTimeout(() => {
    const widgets = [...document.querySelectorAll('loox-snippets-widget')];
    const visibleWidget = widgets.find(w => w.getBoundingClientRect().width > 0);
    const grid = visibleWidget?.shadowRoot?.querySelector('.grid');
    
    if (grid) {
      setInterval(() => {
        const current = grid.scrollLeft;
        const max = grid.scrollWidth - grid.clientWidth;
        grid.scrollLeft = current >= max - 10 ? 0 : current + grid.clientWidth;
      }, 5000);
    }
  }, 1500);
});